import React from 'react'
import _ from 'lodash/fp'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Own things
import { AuthPanel, Chip, validateEmail, validatePasswordConfirm } from './Common'

// Rdx
import { actions as resetPasswordActions, selectors as resetPasswordSelectors } from '../../reducers/resetPassword'

// Material UI things
import IconButton from '@material-ui/core/IconButton'
import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import InputAdornment from '@material-ui/core/InputAdornment'
import FormHelperText from '@material-ui/core/FormHelperText'
import FormControl from '@material-ui/core/FormControl'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import { Send, Save, VisibilityOff, Visibility, ChevronLeft, Done } from '@material-ui/icons'

class ResetPasswordFormFields extends React.Component {
  state = {
    showPassword: false
  }

  render () {
    if (this.props.success) {
      return false
    }
    const emailError = validateEmail(this.props.resendEmail)
    const passwordError = validatePasswordConfirm(this.props.newPassword)(this.props.confirmPassword)
    return (
      <>
        {!this.props.token && !this.props.success && (
          <FormControl
            fullWidth
          >
            <InputLabel>Email</InputLabel>
            <Input
              error={this.props.resendEmail && emailError}
              onChange={(event) => {
                this.props.updateState('resendEmail')(event.target.value)
              }}
              value={this.props.resendEmail}
            />
            <FormHelperText>
              {this.props.resendEmail && emailError}
            </FormHelperText>
          </FormControl>
        )}

        {this.props.token && !this.props.success && (
          <FormControl
            fullWidth
          >
            <InputLabel>Password</InputLabel>
            <Input
              type={this.state.showPassword ? 'text' : 'password'}
              value={this.props.newPassword}
              onChange={(event) => {
                if (_.isEmpty(event.target.value)) {
                  this.props.updateState('confirmPassword')('')
                }
                this.props.updateState('newPassword')(event.target.value)
              }}
              endAdornment={
                <InputAdornment position='end'>
                  <IconButton onClick={() => {
                    this.setState(_.update('showPassword', (sp) => !sp))
                  }}
                  >
                    {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
        )}

        {this.props.token && !this.props.success && (
          <FormControl
            fullWidth
          >
            <InputLabel>Confirm Password</InputLabel>
            <Input
              disabled={_.isEmpty(this.props.newPassword)}
              error={passwordError}
              type={this.state.showPassword ? 'text' : 'password'}
              value={this.props.confirmPassword}
              onChange={(event) => {
                this.props.updateState('confirmPassword')(event.target.value)
              }}
              endAdornment={
                <InputAdornment position='end'>
                  <IconButton disabled>
                    {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
            />

            <FormHelperText>
              {passwordError}
            </FormHelperText>
          </FormControl>
        )}
      </>
    )
  }
}

class ResetPasswordButton extends React.Component {
  clickable = () => {
    return !this.props.loading && (this.props.token
      ? this.props.passwordEquivalens
      : this.props.emailIsValid)
  }

  contentGetter = () => {
    if (this.props.loading) {
      return {
        label: this.props.token ? 'Resetting...' : 'Sending...',
        icon: (<CircularProgress size={24} />)
      }
    } else if (this.props.success) {
      return {
        label: this.props.token ? 'Password reset' : 'Email sent',
        icon: (<Done />)
      }
    } else if (this.props.error) {
      return {
        label: this.props.token ? 'Could not reset password' : 'Could not send email',
        icon: this.props.token ? (<Save />) : (<Send />)
      }
    }
    return {
      label: this.props.token ? 'Reset password' : 'Send reset email',
      icon: this.props.token ? (<Save />) : (<Send />)
    }
  }

  render () {
    const content = this.contentGetter()

    const color = this.props.error
      ? 'secondary'
      : this.clickable() || this.props.success
        ? 'primary'
        : 'default'
    return (
      <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', justifyContent: 'space-around' }}>
        <Chip
          avatar={<Avatar>{_.get('icon', content)}</Avatar>}
          label={_.get('label', content)}
          color={color}
          onClick={this.props.submitFn} //eslint-disable-line
          disabled={!this.clickable()}
        />
      </div>
    )
  }
}

class ResetPassword extends React.Component {
  state = {
    resendEmail: undefined,
    newPassword: undefined,
    confirmPassword: undefined
  }

  updateState = (field) => (val) => {
    this.setState({
      [field]: val
    })
  }

  render () {
    const passwordEquivalens = this.state.confirmPassword && !validatePasswordConfirm(this.state.newPassword)(this.state.confirmPassword)
    const { token } = this.props

    const submitFn = (e) => {
      e.preventDefault()
      console.log('submit')
      if (token) {
        console.log(token, this.state.newPassword)
        this.props.resetPasswordConfirm(token, this.state.newPassword)
      } else {
        console.log(this.state.resendEmail)
        this.props.resetPasswordRequest(this.state.resendEmail)
      }
    }

    if (this.props.confirmSuccess) {
      return (
        <AuthPanel
          header='Reset Password'
        >
          <div style={{ margin: '1em 0' }}>
            <Typography variant='h6'>Password has been reset. You can now log in.</Typography>
          </div>
          <Link to='/login?returnTo=/u/[handle]/profile'>Go to login page</Link>
        </AuthPanel>
      )
    }

    return (
      <AuthPanel
        header='Reset Password'
        action={(
          <Link
            to='/login'
          >
            <Button>
              <ChevronLeft />
              Wait, I remember now
            </Button>
          </Link>
        )}
      >
        <form className='auth-form' onSubmit={submitFn}>
          <div style={{ margin: '1em 0' }}>
            <ResetPasswordFormFields
              token={token}
              newPassword={this.state.newPassword}
              confirmPassword={this.state.confirmPassword}
              resendEmail={this.state.resendEmail}
              updateState={this.updateState}
              passwordEquivalens={passwordEquivalens}
              success={token ? this.props.confirmSuccess : this.props.success}
            />
          </div>
          <div style={{ margin: '1em 0' }}>
            <ResetPasswordButton
              submitFn={submitFn}
              token={token}
              loading={token ? this.props.confirmLoading : this.props.loading}
              success={token ? this.props.confirmSuccess : this.props.success}
              error={token ? this.props.confirmError : this.props.error}
              passwordEquivalens={passwordEquivalens}
              emailIsValid={!validateEmail(this.state.resendEmail)}
            />
          </div>
        </form>
      </AuthPanel>
    )
  }
}

export default _.compose(
  connect(
    (s, ownProps) => {
      return {
        token: ownProps.match.params.resetToken,
        loading: resetPasswordSelectors.loading(s),
        success: resetPasswordSelectors.success(s),
        error: resetPasswordSelectors.error(s),
        confirmLoading: resetPasswordSelectors.confirmLoading(s),
        confirmSuccess: resetPasswordSelectors.confirmSuccess(s),
        confirmError: resetPasswordSelectors.confirmError(s)
      }
    },
    (d, ownProps) => {
      return {
        resetPasswordConfirm: (token, password) => d(resetPasswordActions.confirmRequest({ token, password })),
        resetPasswordRequest: (email) => d(resetPasswordActions.submitRequest({ email }))
      }
    }
  )
)(ResetPassword)
